import { Component, OnInit } from '@angular/core';
import { BlogPost, BlogPosts } from 'src/app/data/blog';

@Component({
  selector: 'app-dashboard-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class DashboardBlogComponent implements OnInit {
  blogPosts: BlogPost[] = BlogPosts;

  constructor() { }

  ngOnInit(): void {
  }

}
